
interface NavbarContainerProps { children?: any }
export function NavbarContainer({ children }:NavbarContainerProps){
    return  <div 
        className="bg-docpace dark:bg-docpace-dark navbar sticky flex justify-between relative shadow-md h-12  z-[200]"
        id='header'
    >
        { children }
    </div>
}